// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p0-0";
export var animationContainer = "_p0-1";
export var itemPrice = "_p0-a";
export var itemizedContent = "_p0-9";
export var itemizedHeader = "_p0-7";
export var itemizedRow = "_p0-8";
export var itemizedSection = "_p0-6";
export var modalContent = "_p0-2";
export var orderName = "_p0-3";
export var refundOption = "_p0-4";
export var refundOptionsContainer = "_p0-5";
export var shippingLabel = "_p0-b";
export var totalRow = "_p0-c";